<script lang="ts">
	import { isRTL } from '$lib/stores/directionStore';

	import Icon from '$lib/components/Icon/Icon.svelte';
	import type { HeaderTitles } from '$lib/types/HeaderTitles';

	export let header: HeaderTitles[];

	$: headerLast = header[header.length - 1];

	export let changePage: (page: number) => void;
</script>

<div class="header">
	<div class="title-row">
		{#if header.length > 1}
			<Icon
				onClick={() => changePage(header.length - 2)}
				icon={$isRTL ? 'right-chevron' : 'left-chevron'} />
		{/if}
		{#each header as t, i}
			{#if i === header.length - 1}
				<span class="lastTitle">{t.navigation}</span>
			{:else}
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<!-- svelte-ignore a11y-no-static-element-interactions -->
				<span on:click={() => changePage(i)} class="previousTitle">{t.navigation}</span>
				<span class="slash">/</span>
			{/if}
		{/each}
	</div>
	<div class="titles">
		{#if headerLast.pretitle}
			<div class="subtitle">{headerLast.pretitle}</div>
		{/if}
		<span class="title">{headerLast.title}</span>
		<span class="subtitle">{headerLast.subtitle}</span>
	</div>
</div>

<style>
	.header {
		display: flex;
		flex-direction: column;
		margin-block-start: 20px;
	}

	.titles {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		margin-block: 2rem 1rem;
		text-align: start;
	}

	.titles .title {
		font-size: xx-large;
		font-weight: bold;
	}

	.titles .subtitle {
		block-size: 20px;
		color: rgb(105 126 142);
		font-size: 1.5rem;
	}

	.title-row {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.title-row span {
		margin-inline-start: 3px;
	}

	.title-row .lastTitle {
		font-weight: bolder;
	}

	.title-row .previousTitle:hover {
		text-decoration: underline;
		cursor: pointer;
	}
</style>
